import {
    addContainerClassesNoRules,
    multiClasses,
} from '@dat/iq-style-processor';
import { Component as ComponentType } from '../../models';
import { idCreator } from '../../models/builder-utils';
import { Control } from '@dat/iq-controls';
import { Controls } from './shared.models';

// #region Title Components

export const ViewTitleComponents: (idRoot: string) => ComponentType[] = (
    idRoot: string,
) => [
    {
        id: idCreator(idRoot, ['title']),
        type: 'Controls',
        onClick: [
                {
                    name: 'iframePostMessage',
                    payload: {
                        type: 'IFRAME_NAVIGATE_URL',
                        payload: {
                            url: '/trendlines',
                        },
                    },
                sourceEventRule: {
                    payload: [
                        {
                            path: 'control.id',
                            operator: 'eq',
                            value: idCreator(idRoot, ['title', 'image']),
                        }
                    ]
                }
            }
        ],
        props: {
            id: idCreator(idRoot, ['title']),
            controls: [
                {
                    type: 'Action',
                    id: idCreator(idRoot, ['title', 'image']),
                    label: '<img class="h-[135px] w-[75%] sm:w-[72%] sm:h-[55px] sm:px-[25px] tablet:px-[25px]"  src="/assets/trendlines/trendlines-logo.svg" alt="Trendlines" fetchpriority="high"/>',
                },
            ],
            classNames: {
                ...addContainerClassesNoRules(['text-white']),
            },
        },
    },
    {
        id: idCreator(idRoot, ['ff-register']),
        type: 'TrendLinesFfRegister',
        props: {
            id: idCreator(idRoot, ['ff-register']),
        }
    }
];

// #endregion Title Components

// #region Header Components

export const ViewHeaderComponents: (idRoot: string) => ComponentType[] = (
    idRoot: string,
) => [
    {
        id: idCreator(idRoot, ['header']),
        type: 'Label',
        props: {
            id: idCreator(idRoot, ['header']),
            label: `<h3 class="tl-page-subtitle m-0 mt-5 w-[50%] sm:w-full sm:px-[25px] tablet:px-[25px]">See where freight rates are heading, with the deepest, broadest data in the trucking industry</h3>
            `,
        },
        classNames: {
            ...addContainerClassesNoRules(['!text-white']),
        },
    },
];

// #endregion Header Components

// #region Weekly Snapshot Components

export const WeeklySnapshotComponents: (idRoot: string) => ComponentType[] = (
    idRoot: string,
) => [
    {
        id: idCreator(idRoot, ['header']),
        type: 'Label',
        props: {
            label: `<h2 class="tl-section-header text-white m-0 pb-10 sm:px-[25px] tablet:px-[25px]">Weekly snapshot by the numbers</h2>`,
        },
        classNames: {
            ...multiClasses(
                ['!bg-tl-default'],
                [`[data-styleid="${idCreator(idRoot, ['header'])}"]`],
            ),
        },
    },
    {
        ...Controls(idRoot, '/trendlines'),
        classNames: {
            ...addContainerClassesNoRules([
                'w-full',
                'flex',
                'justify-end',
                'sm:justify-center',
                'bg-black',
            ]),
        },
    },
    {
        id: idCreator(idRoot, ['table']),
        type: 'TrendLineSnapshotTable',
        classNames: {
            ...addContainerClassesNoRules([
                'text-white',
                'sm:overflow-x-scroll',
            ]),
        },
        props: {
            id: idCreator(idRoot, ['table']),
        },
    },
];

// #endregion Weekly Snapshot Components

// #region National Spot Rates Components
export const NationalSpotRatesComponents: (idRoot: string) => ComponentType[] = (
    idRoot: string,
) => [
    {
        id: idCreator(idRoot, ['header']),
        type: 'Label',
        props: {
            id: 'test-header-title',
            label: `<h2 class="tl-section-header text-white m-0 sm:pr-[25px] tablet:px-[25px] ">National Spot Rates</h2>`,
        },
        classNames: {
            ...multiClasses(
                ['!bg-tl-default'],
                [`[data-styleid="${idCreator(idRoot, ['header'])}"]`],
            ),
            ...addContainerClassesNoRules(['tablet:col-span-3']),
        },
    },
    {
        id: idCreator(idRoot, ['current-state']),
        type: 'Label',
        props: {
            id: idCreator(idRoot, ['current-state', 'label']),
            flag: 'iq_com_trendline_weekly_brief',
            flagLabel: 'spot_blurb',
        },
        classNames: {
            ...addContainerClassesNoRules(['!text-white', 'col-span-3']),
            ...multiClasses(
                [
                    'tl-section-subheader',
                    'my-0',
                    'sm:mx-[10px]',
                    'tablet:mx-[10px]',
                    'pb-5',
                    'sm:block',
                    'sm:px-[25px]',
                    'tablet:block',
                    'tablet:px-[25px]',
                ],
                ['[data-uitype="label"]'],
            ),
        },
    },
    {
        id: idCreator(idRoot, ['van']),
        type: 'TrendlinesNtlSpotVan',
        props: {
            id: idCreator(idRoot, ['van']),
        },
        classNames: {
            ...addContainerClassesNoRules([
                'col-span-1',
                'sm:col-span-3',
                'tablet:col-span-3',
                'tablet:justify-self-center',
            ]),
        },
    },
    {
        id: idCreator(idRoot, ['van-label-mobile']),
        type: 'Label',
        props: {
            id: idCreator(idRoot, ['van-label-mobile']),
            label: `**VAN**`,
        },
        classNames: {
            ...addContainerClassesNoRules([
                '!text-white',
                'hidden',
                'sm:block',
                'tablet:block',
                'tablet:justify-self-center',
                'tablet:col-span-3',
            ]),
        },
    },
    {
        id: idCreator(idRoot, ['flabed']),
        type: 'TrendlinesNtlSpotFlatbed',
        props: {
            id: idCreator(idRoot, ['flabed']),
        },
        classNames: {
            ...addContainerClassesNoRules([
                'col-span-1',
                'sm:col-span-3',
                'tablet:col-span-3',
                'tablet:justify-self-center',
            ]),
        },
    },
    {
        id: idCreator(idRoot, ['flatbed-label-mobile']),
        type: 'Label',
        props: {
            id: idCreator(idRoot, ['flatbed-label-mobile']),
            label: `**FLATBED**`,
        },
        classNames: {
            ...addContainerClassesNoRules([
                '!text-white',
                'hidden',
                'sm:block',
                'tablet:block',
                'tablet:justify-self-center',
                'tablet:col-span-3',
            ]),
        },
    },
    {
        id: idCreator(idRoot, ['reefer']),
        type: 'TrendlinesNtlSpotReefer',
        props: {
            id: idCreator(idRoot, ['Reefer']),
        },
        classNames: {
            ...addContainerClassesNoRules([
                'col-span-1',
                'sm:col-span-3',
                'tablet:col-span-3',
                'tablet:justify-self-center',
            ]),
        },
    },
    {
        id: idCreator(idRoot, ['reefer-label-mobile']),
        type: 'Label',
        props: {
            id: idCreator(idRoot, ['reefer-label-mobile']),
            label: `**REEFER**`,
        },
        classNames: {
            ...addContainerClassesNoRules([
                '!text-white',
                'hidden',
                'sm:block',
                'tablet:block',
                'tablet:justify-self-center',
                'tablet:col-span-3',
            ]),
        },
    },
    {
        id: idCreator(idRoot, ['van-label']),
        type: 'Label',
        props: {
            id: idCreator(idRoot, ['van-label']),
            label: `**VAN**`,
        },
        classNames: {
            ...addContainerClassesNoRules([
                '!text-white',
                'sm:hidden',
                'block',
                'tablet:hidden',
            ]),
        },
    },
    {
        id: idCreator(idRoot, ['flabed-label']),
        type: 'Label',
        props: {
            id: idCreator(idRoot, ['flabed-label']),
            label: `**FLATBED**`,
        },
        classNames: {
            ...addContainerClassesNoRules([
                '!text-white',
                'sm:hidden',
                'block',
                'tablet:hidden',
            ]),
        },
    },
    {
        id: idCreator(idRoot, ['reefer-label']),
        type: 'Label',
        props: {
            id: idCreator(idRoot, ['reefer-label']),
            label: `**REEFER**`,
        },
        classNames: {
            ...addContainerClassesNoRules([
                '!text-white',
                'sm:hidden',
                'block',
                'tablet:hidden',
            ]),
        },
    },
];
// #endregion National Spot Rates Components

// #region Weekly Brief Components

export const WeeklyBriefComponents: (idRoot: string) => ComponentType[] = (
    idRoot: string,
) => [
    {
        id: idCreator(idRoot, ['header']),
        type: 'Label',
        props: {
            label: `<h2 class="tl-section-header text-white m-0">Weekly Brief</h2>`,
        },
        classNames: {
            ...addContainerClassesNoRules([
                'col-span-3',
                'tablet:col-span-1',
                '!bg-black',
                'py-5',
                'row-start-1',
                'pl-[35px]',
                'pr-[50px]',
            ]),
        },
    },
    {
        id: idCreator(idRoot, ['latest-link']),
        type: 'Label',
        props: {
            id: idCreator(idRoot, ['latest-link']),
            label: `<div class="p-[50px] grid grid-rows-1 grid-cols-1">
            <img
              class="w-[67px] inline-block mb-[10px]"
              src="/assets/trendlines/trendlines-iq-analytics-logo.svg"
              alt="DAT iQ Analytics Logo"
              loading="lazy"
            />
            <section class="tl-weekly-brief-label-strong">
              See the latest rates and forecast for every market and every lane with DAT<span class="lowercase">i</span>Q
              analytics.
            </section>
            <a
              class="text-white uppercase no-underline hover:underline font-caption"
              href="https://www.dat.com/iq" target="_parent"
              >Learn More</a
            >
          </div>
          `,
        },
        classNames: {
            ...addContainerClassesNoRules([
                'col-span-1',
                'col-start-4',
                'row-span-2',
                'text-white',
                'tablet:col-start-1',
                'tablet:row-start-3',
                'self-stretch',
                'sm:order-last',
                'tablet:order-last',
            ]),
        },
    },
    {
        id: idCreator(idRoot, ['current-brief']),
        type: 'TrendlineWeeklyBrief',
        props: {
            id: idCreator(idRoot, ['current-brief']),
        },
        classNames: {
            ...addContainerClassesNoRules([
                'col-span-3',
                'tablet:col-span-1',
                'bg-black',
                '!text-white',
                'py-4',
                'row-start-2',
                'pl-[35px]',
                'pr-[50px]',
            ]),
            ...multiClasses(['h-full'], [`[data-uitype="builder-component"]`]),
        },
    },
];
// #endregion Weekly Brief Components

// #region Fuel Prices Components

export const ViewFuelPriceComponents: (idRoot: string) => ComponentType[] = (
    idRoot: string,
) => [
    {
        id: idCreator(idRoot, ['header']),
        type: 'Label',
        props: {
            label: `<h2 class="tl-section-header text-white m-0 mb-5 sm:px-[25px] tablet:px-[25px]">Fuel Prices</h2>`,
        },
        classNames: {
            ...multiClasses(
                ['!bg-tl-default'],
                [`[data-styleid="${idCreator(idRoot, ['header'])}"]`],
            ),
        },
    },
    {
        id: idCreator(idRoot, ['label']),
        type: 'Label',
        props: {
            id: idCreator(idRoot, ['label', 'description']),
            label: `<h6 class="tl-section-subheader m-0 pb-[70px] sm:pb-[50px] sm:px-[25px] tablet:px-[25px] tablet:pb-[50px]">Current national diesel fuel price average</h6>`,
        },
        classNames: {
            ...addContainerClassesNoRules(['text-white', 'm-0']),
        },
    },
    {
        id: idCreator(idRoot, ['prices']),
        type: 'TrendlineFuelPrices',
        props: {
            id: idCreator(idRoot, ['prices-label']),
        },
        classNames: {
            ...addContainerClassesNoRules(['text-white', 'pb-[100px]','tablet:px-[25px]']),
        },
    },
];

// #endregion Fuel Prices Components

// #region Additional Information

const WatchDatIq = `Watch DAT iQ Live: Join the DAT iQ team live on <a href="http://youtube.com/c/DATLoadBoards/live" target="_blank"><strong>YouTube</strong></a> or <a href="https://www.linkedin.com/company/datsolutions/events/" target="_blank"><strong>LinkedIn Live</strong></a> weekly.`;
const Benchmark = `NEW! Get deep visbility into contract rates with <a href="https://www.dat.com/benchmark-analytics" target="_parent"><strong>DAT IQ Benchmark</strong></a>.`;
const Ratecast = `Get a clear view of tomorrow's rates with the one-of-a-kind RATECAST tool from DAT iQ. <a href="https://www.dat.com/rateview/ratecast" target="_parent"><strong>Learn More</strong></a>`;
const Blog = `For the latest market updates, visit the <a href="https://www.dat.com/blog" target="_parent"><strong>DAT blog</strong></a>.`;
const Rateview = `Trendlines shows a weekly snapshot of the month-to-date for national average rates from <a href="https://www.dat.com/rateview" target="_parent"><strong>DAT</strong> RateView</a>. National average spot market rates for the past four months, including fuel surcharges, are shown in the three graphs, above.`;
const SpecialOffer = `SPECIAL OFFER: FREE 50-LANE LOOK UP <br/>
Benchmark your rates against $1 trillion in actual transactions. <br/>
<strong><a href="https://www.dat.com/rateview" target="_parent">Learn More</strong></a>`;

export const AdditionalInformationComponents: (
    idRoot: string,
) => ComponentType[] = (idRoot: string) => [
    ...[WatchDatIq, Benchmark, Ratecast, Blog, Rateview, SpecialOffer].map(
        (label, index): ComponentType => ({
            id: idCreator(idRoot, ['notes', `${index}`]),
            type: 'Label',
            props: {
                id: idCreator(idRoot, ['notes', `${index}`]),
                label: `${label}`,
            },
            classNames: {
                ...addContainerClassesNoRules([
                    'col-span-1',
                    'text-white',
                    'w-full',
                    'inline-block',
                    'text-center',
                    'tl-trends-info-link',
                ]),
                ...multiClasses(
                    [
                        '!w-full',
                        'py-5',
                        'px-5',
                        '!text-center',
                        'flex',
                        'items-center',
                        'border-0',
                        'border-solid',
                        'border-dat-blue-500',
                        `border-t-[${index === 0 ? '1px' : '0px'}]`,
                        'border-b-[1px]',
                    ],
                    ['[data-uitype="label"]'],
                ),
                ...multiClasses(['!w-full', '!text-center'], ['p']),
                ...multiClasses(
                    ['text-dat-blue-500', 'no-underline', 'hover:underline'],
                    ['a'],
                ),
            },
        }),
    ),

    {
        id: idCreator(idRoot, ['cta']),
        type: 'Controls',
        props: {
            id: idCreator(idRoot, ['cta-controls']),
            controls: [
                {
                    id: idCreator(idRoot, ['cta-controls', 'button']),
                    type: 'Action',
                    label: '<a href="https://www.dat.com/rateview" class="flex justify-center w-full h-full p-2 rounded-l-full rounded-r-full" target="_parent"><span class="material-symbols-outlined inline-block mr-2 ">query_stats</span> Check Out DAT Rateview</a>',
                    classes: {
                        ...multiClasses(
                            [
                                'w-2/3',
                                'rounded-full',
                                'bg-dat-blue-500',
                                'hover:bg-dat-blue-600',
                                'active:bg-dat-blue-400',
                                'label',
                                '!text-white',
                                'cursor-pointer',
                                '!tl-trends-check-out',
                                'uppercase',
                                'mt-[25px]',
                            ],
                            ['[data-uitype="button"]'],
                        ),
                        ...multiClasses(
                            ['!flex', 'justify-center', 'items-center'],
                            ['p'],
                        ),
                    },
                } as Control,
            ],
        },
        classNames: {
            ...addContainerClassesNoRules([
                'col-span-1',
                'text-white',
                'w-full',
                'inline-block',
                'text-center',
            ]),
            ...multiClasses(
                [
                    '!w-full',
                    'py-5',
                    'px-5',
                    '!text-center',
                    'flex',
                    'items-center',
                ],
                ['[data-uitype="label"]'],
            ),
        },
    },
];

// #endregion Additional Information

// #region About Trendlines Components
const vanDemandAndCapacity = {
    label: 'Van Demand & Capacity',
    url: '/trendlines/van/demand-and-capacity',
};
const vanSpotMarketRates = {
    label: 'Van Spot Market Rates',
    url: '/trendlines/van/national-rates',
};
const flatbedDemandAndCapacity = {
    label: 'Flatbed Demand & Capacity',
    url: '/trendlines/flatbed/demand-and-capacity',
};
const flatbedSpotMarketRates = {
    label: 'Flatbed Spot Market Rates',
    url: '/trendlines/flatbed/national-rates',
};
const reeferDemandAndCapacity = {
    label: 'Reefer Demand & Capacity',
    url: '/trendlines/reefer/demand-and-capacity',
};
const reeferSpotMarketRates = {
    label: 'Reefer Spot Market Rates',
    url: '/trendlines/reefer/national-rates',
};

const AboutTrendlinesLinkComponent: (
    idRoot: string,
    payload: { label: string; url: string },
) => ComponentType = (idRoot, payload) => {
    return {
        id: idCreator(idRoot, ['link', payload.label]),
        type: 'Controls',
        onClick: [{
            name: 'iframePostMessage',
            payload: {
                type: 'IFRAME_NAVIGATE_URL',
                payload: {
                    url: payload.url,
                },
            },
            sourceEventRule: {
                payload: [
                {
                    path: 'control.id',
                    operator: 'eq',
                    value: idCreator(idRoot, [payload.label,'link']),
                }]
            }
        }],
        props: {
            id: idCreator(idRoot, [payload.label]),
            controls: [
                {
                    type: 'Action',
                    id: idCreator(idRoot, [payload.label, 'link']),
                    label: payload.label,
                    classes: {
                        ...multiClasses(
                            [
                                'no-underline',
                                'hover:underline',
                                'tl-about-link',
                                'text-[15px]',
                            ],
                            ['p'],
                        ),
                    },
                },
            ],
        },
    };
};

export const AboutTrendlinesComponents: (idRoot: string) => ComponentType[] = (
    idRoot: string,
): ComponentType[] => [
    {
        id: idCreator(idRoot, ['about-trend-lines-info', 'label']),
        type: 'Label',
        props: {
            id: idCreator(idRoot, ['label', 'content', 'about']),
            label: `DAT Trendlines is a free weekly spot market freight report, providing an overview of national freight market trends. The average trucking rates are based on DAT iQ's $1 trillion database of actual freight payments.<br><br>

The report includes a weekly snapshot of the rolling month-to-date national average trucking rates for van, reefer and flatbed. National average rates in Trendlines are for lanes of 250 miles or more.<br><br>

Trendlines also includes national supply and demand metrics based on load and truck posts on the DAT One load board network by freight brokers, shippers and carriers.<br><br>

You can also explore historical monthly trucking industry trends and compare spot trucking freight rates to the contract rates that shippers pay directly to carriers by visiting the links below:<br><br>
`,
        },
        classNames: {
            ...addContainerClassesNoRules([
                'text-dat-grey-300',
                'tl-trends-info-link',
            ]),
        },
    },
    ...[
        vanDemandAndCapacity,
        vanSpotMarketRates,
        flatbedDemandAndCapacity,
        flatbedSpotMarketRates,
        reeferDemandAndCapacity,
        reeferSpotMarketRates,
    ].map((link) => {
        return AboutTrendlinesLinkComponent(idRoot, link);
    }),
    {
        id: idCreator(idRoot, ['about-trend-lines-disclamer', 'label']),
        type: 'Label',
        props: {
            id: idCreator(idRoot, ['label', 'content', 'about']),
            label: `<br/><br/>The national trends reported in DAT Trendlines are not necessarily reflective of trends that freight brokers, shippers and carriers may be seeing in individual trucking lanes or regions. To fully understand market and truckload pricing dynamics in your lanes, DAT provides a full suite of freight rate and market data available from <a href="https://www.dat.com/iq" class="text-dat-blue-500" target="_parent">DAT iQ</a> or tools in <a href="https://www.dat.com/one" class="text-dat-blue-500" target="_parent">DAT One</a> load boards.<br><br>

To access the full history of DAT Trendlines reports, <a href="https://cloud.comms.dat.com/sales-inquiry-professional-services?_gl=1*l0mf9s*_ga*MTExNjE5OTg0NS4xNzA4Mzc5MjM3*_ga_C36TRC5CVZ*MTcxMDQ0NzM3MC4xNi4xLjE3MTA0NDkwMjMuMC4wLjA.*_ga_QYVEY2GZSM*MTcxMDQ0NzM3MC4xNy4wLjE3MTA0NDczNzMuMC4wLjA.*_gcl_au*NTAzODQzOTU2LjE3MDgzNzkyMzc." class="text-dat-blue-500" target="_parent">contact DAT’s Analytics Services team.</a>`,
        },
        classNames: {
            ...addContainerClassesNoRules([
                'text-dat-grey-300',
                'tl-trends-info-link',
            ]),
        },
    },
];

// #endregion About Trendlines Components
